<template>

  <div class="index-container" data-title="登录">
    <mt-spinner v-show="initialloading" type="snake" color="#00ccff" :size="20"></mt-spinner>
    <div class="top">
      <div class="icon-area">
        <div class="img-style">
          <img :src="headimgurl" />
        </div>
        <span>{{user.curMemberGrade}}</span>
        <!-- {{nextValue>0?user.curMemberGrade:user.nextMemberGrade}} -->
      </div>
      <div class="top-content">
        <div class="uname">
          <div class="name" @click="goToInfo">{{nickname}}</div>
          <div class="mobile">{{user.mobile}}</div>
        </div>
        <!-- <div @click="goToGrowthValue"> -->
        <div>
          <span class="growth-style">{{nextValue>0?('再消费'+nextValue+'元即可升至'+user.nextMemberGrade):'当前已为最高等级'}}</span>
          <mt-progress :value="growth"></mt-progress>
        </div>
        <div class="knowledge" @click="goToKnowledge">会员须知</div>
      </div>
    </div>
    <div class="nav">
      <router-link class="nav-items" :to="{path:'/Member/RemaindSum',query: {amount: user.cashAmount}}">
        <span>{{user.cashAmount}}</span>我的余额
      </router-link>
      <!-- <div class="nav-items" >
          <wx-open-launch-weapp id="launch-btn" appid="wx5092d36f499920da" path="home/index/index?go=personalCenter/centerPage/centerPage">我的积分</wx-open-launch-weapp>
      </div> -->
      <router-link class="nav-items" :to="{path:'/Member/Integral',query: {score: user.score}}"> 
        <span>{{user.score}}</span>我的积分
      </router-link>
      <div class="card-nav">&nbsp;</div>
    </div>
    <div class="advertise-img">
      <!-- <div class="banner1 bannerItem">
        <mt-swipe :auto="4000">
          <mt-swipe-item>
            <img src="../../assets/img/banner-one.png" />
          </mt-swipe-item>
          <mt-swipe-item>
            <img src="../../assets/img/banner-two.png" />
          </mt-swipe-item>
        </mt-swipe>
      </div> -->
      <template v-if="imglist&&imglist.length>1">
        <div class="banner1 bannerItem">
          <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(item,index) in imglist" :key="index">
              <img :src="item.url" alt @click="toLink(item.linkUrl)" />
            </mt-swipe-item>
          </mt-swipe>
        </div>
      </template>
      <template v-else-if="imglist&&imglist.length==1">
        <img :src="imglist[0].url" @click="toLink(imglist[0].linkUrl)" />
      </template>
      <template v-else>
        <div class="banner1 bannerItem">
          <mt-swipe :auto="4000">
            <mt-swipe-item>
              <img src="../../assets/img/banner-one.png" />
            </mt-swipe-item>
            <mt-swipe-item>
              <img src="../../assets/img/banner-two.png" />
            </mt-swipe-item>
          </mt-swipe>
        </div>
      </template>
    </div>

    <!--未关注会员关注按钮 start-->
    <div class="member-subscribe-div" @click="subscribeWechat()" v-if="!isSubscribe">
      <img src="../..//assets/img/subscribe-btn.jpg">
      <span>关注公众号</span>
    </div>
    <!--关注弹出二维码-->
    <modalTemp class="sing-success-modal" :showModal="subscribeModalStatus" @closeModal="closeSubscribeWechat">
      <div slot="header" @click="closeSubscribeWechat()">
        <div class="member-subscribe-close">x</div>
      </div>
      <div slot="content" class="member-subscribe-content">
        <img :src="subscribeQrImg" />
        <span>长按二维码识别关注</span>
      </div>
      <div slot="footer"></div>
    </modalTemp>
    <!--未关注会员关注按钮 end-->

    <div class="menu-list">
      <div class="line-items">
        <router-link class="content" :to="{path:'/Member/pay',query:{cashAmount:user.cashAmount,curMemberGrade: user.curMemberGrade}}">
          <img src="../../assets/img/pay.png" />会员码
        </router-link>
        <router-link class="content" to="/Member/Order">
          <img src="../../assets/img/order.png" />我的订单
        </router-link>
        <router-link class="content" to="/Member/Recharge">
          <img src="../../assets/img/recharge.png" />充值
        </router-link>
      </div>
      <div class="line-items">
        <router-link class="content" :to="{path:'/Member/SaleDetail',query: {amount: user.cashAmount}}">
          <img src="../../assets/img/sale.png" />交易明细
        </router-link>
        <router-link class="content" to="/Member/SignIn">
          <img src="../../assets/img/sign.png" />签到有礼
        </router-link>
        <router-link class="content" to="/Member/Coupon">
          <img src="../../assets/img/coupon.png" />优惠券
        </router-link>
      </div>
      <div class="line-items">
        <router-link class="content" to="/Member/Info">
          <img src="../../assets/img/info.png" />编辑资料
        </router-link>
        <router-link class="content" to="/Member/Member">
          <img src="../../assets/img/member.png" />会员权益
        </router-link>
        <router-link class="content" :to="{path:'/Member/Set',query: {mobile: user.curMobile+''}}">
          <img src="../../assets/img/set.png" />设置
        </router-link>
      </div>
      <div class="line-items">
        <a class="content" href="http://waplottery.huangyebl.com">
          <img src="../../assets/img/coupon.png" />会员抽奖
        </a>
        <!-- <wx-open-launch-weapp class="content" appid="wx5092d36f499920da" path="home/index/index?go=personalCenter/centerPage/centerPage">
          <script type="text/wxtag-template">
            <style>.goMina {width: 100%; text-align: center;}</style>
            <div class="goMina">会员俱乐部</div>            
          </script>
            
          </wx-open-launch-weapp>
         -->
         <!--
               <style>
                 img {
                margin-bottom: 5px;
                width: 25px;
                height: 25px;
            }
            </style>
            <img src="data:image/png;base64,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"/>  -->
            
        <router-link class="content" to=""> </router-link>
        <router-link class="content" to=""> </router-link>
      </div>
      <!-- <div class="line-items">
        <router-link class="content" to="/Member/Clear">清空缓存</router-link>
      </div>-->
    </div>

    <gfooter></gfooter>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { mapActions } from "vuex";
import avatar from "@/assets/img/avatar.jpg";
import common from "@/libs/common";
import { localToken } from "@/libs/func";
import { Swipe, SwipeItem } from "mint-ui";
import advertApi from "@/api/api-advert";
import globConfig from "@/config/config";
import modalTemp from "@/components/modal";
import userApi from "@/api/api-user";
import QRCode from "qrcode";

export default {
  name: "Index",
  components: {
    modalTemp,
  },
  data() {
    return {
      user: {
        mobile: null, // 部分隐藏手机号
        curMobile: null, // 手机号
        curMemberGrade: "未知", // 当前等级
        nextMemberGrade: "未知", // 目标等级
        nextGradeGrowValue: 0, // 下一个等级成长值
        ratetoNext: 0,
        score: 0,
        growth: 0,
        cashAmount: 0,
      },
      progressWidth: 60, // 进度条宽度
      initialloading: true,
      headimgurl: null,
      nickname: "未知",
      growth: 0,
      nextValue: 0, // 距下一个等级还差多少
      imglist: [], //首页广告图片

      //关注公众号相关
      isSubscribe: true,
      subscribeModalStatus: false,
      subscribeQrImg: "",
    };
  },
  methods: {
    ...mapActions(["getUserInfo", "checkMp"]),
    goToInfo() {
      this.$router.push({
        path: "/Member/Info",
      });
    },
    goToGrowthValue() {
      common.toJump(this, "/Member/GrowthValue", {
        GrowthValueNum: this.user.growth,
        // NeedGrowthValueNum: this.user.nextGradeGrowValue,
        NeedGrowthValueNum: this.nextValue,
        curMemberGrade: this.user.curMemberGrade,
        nextMemberGrade: this.user.nextMemberGrade,
        growth: this.growth,
      });
    },
    goToKnowledge() {
      common.toJump(this, "/Member/Knowledge");
    },
    getBaseInfo() {
      let that = this;
      that.getUserInfo().then(
        (res) => {
          res.cashAmount = common.toDecimal2(res.cashAmount);
          that.headimgurl = res.img ? res.img : avatar;
          that.nickname = res.name ? res.name : "未知";
          that.user = res;
          // 保存个人信息
          localToken.setMobile(res.mobile);
          that.user.curMobile = res.mobile;
          that.user.mobile =
            res.mobile.substr(0, 3) + "****" + res.mobile.substr(7);
          // Max 为最高等级
          if (
            res.nextMemberGrade == "Max" ||
            res.growth > parseInt(res.nextGradeGrowValue)
          ) {
            that.growth = 100;
            that.nextValue = 0;
          } else {
            that.growth =
              Math.round(
                (res.growth / parseInt(res.nextGradeGrowValue)) * 10000
              ) / 100.0;
            that.nextValue = res.nextGradeGrowValue - res.growth;
          }
        },
        (err) => {
          that.headimgurl = avatar;
        }
      );
      that.initialloading = false;
    },
    // 获取首页广告图片
    getAdvertList() {
      let that = this;
      let WeixinMpId = localToken.getMp();
      advertApi
        .getAdvertList({ AdvertTagType: 2, WeixinMpId: WeixinMpId })
        .then(
          (res) => {
            that.imglist = res;
          },
          (err) => {
            console.log(err, "获取首页广告图片失败！");
          }
        );
    },
    toLink(linkUrl) {
      let that = this;
      let isInside = false;

      if (linkUrl) {
        console.log(linkUrl);
        // linkUrl.includes(globConfig.linkUrl) // 判断是否为内部链接
        // linkUrl.startsWith("http") // 判断是否完整链接
        // 不是内部链接情况下做特殊处理=》加参数=》判断=》顺利到达指定页面
        if (linkUrl.startsWith("http")) {
          isInside = true;
          window.location.href = linkUrl;
          return;
        }
        if (!linkUrl.includes(globConfig.linkUrl)) {
          isInside = true;
        }
        that.$router.push({
          path: linkUrl,
          query: { isInside: isInside },
        });
      }
    },

    //关注公众号二维码
    getSubscribeStatus() {
      let that = this;
      userApi
        .userSubscribeStatus()
        .then((res) => {
          that.isSubscribe = !!res.status; //0未关注 1已关注
          let _url = res.url || "";
          QRCode.toDataURL(
            _url,
            { errorCorrectionLevel: "L" },
            function (err, url) {
              that.subscribeQrImg = url;
              //console.log('qrurl', url);
            }
          );
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },

    subscribeWechat() {
      let that = this;
      that.subscribeModalStatus = true;
      console.log("显示关注二维码");
    },

    closeSubscribeWechat() {
      let that = this;
      that.subscribeModalStatus = false;
    },
  },
  mounted() {
    this.getBaseInfo();
    this.getAdvertList();
    this.getSubscribeStatus();
    let mp = this.$route.query.mp || null;

    if (mp) {
      this.checkMp(mp);
    }
    // 获取首页广告
  },
};
</script>

<style lang="less">
body {
  background-color: rgba(255, 255, 255, 0) !important;
}
// body,
// #app {
//   height: 100%;
// }
.index-container {
  height: inherit;
  // background: #fff;

  /*关注公众号按钮*/
  .member-subscribe-div {
    width: 96%;
    margin: 0 auto;
    padding: 10px;
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    img {
      width: 20px;
      margin-left: 5px;
    }
    span {
      margin-left: 5px;
    }
  }
  .member-subscribe-content {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    * {
      padding: 5px;
    }
    img {
      /*   width: 200px;*/
      width: 100%;
      margin: 0 auto;
    }
    span {
      display: block;
      width: 100%;
      text-align: center;
      color: #bb342f;
    }
  }
  .member-subscribe-close {
    width: 30px;
    height: 30px;
    font-size: 20px;
    padding: 10px;
    color: #999;
    margin-left: 85%;
    line-height: 10px;
  }

  .top {
    display: flex;
    align-items: center;
    height: 120px;
    width: 100%;
    background: #fff;
    .icon-area {
      margin: 0 10px;
      height: 75px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
      .img-style {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        border: 2px solid #d80c18;
      }
      span {
        font-size: 12px;
        color: #fff;
        background-color: #d80c18;
        padding: 0px 10px;
        border-radius: 5px;
        position: absolute;
        bottom: 0px;
      }
    }
    .top-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      height: 70px;
      // width: 60%;
      padding-right: 10%;
      position: relative;
      flex: 1;
      .knowledge {
        position: absolute;
        top: -10px;
        color: #999;
        font-size: 12px;
        right: 15px;
        border-bottom: 1px solid #999;
        letter-spacing: 1px;
      }
      .uname {
        margin-bottom: 6px;
        font-size: 12px;
        display: flex;
        align-items: center;
        .name {
          margin-right: 10px;
          color: #1a1a1a;
          font-size: 14px;
          font-weight: bold;
          max-width: 100px;
          overflow: hidden;
          word-break: keep-all;
        }
        .mobile {
          flex: 1;
        }
      }

      span {
        font-size: 12px;
      }
      .growth-style {
        overflow: hidden;
        word-break: keep-all;
      }
      .mt-progress {
        margin-top: 6px;
        height: 6px;
        border: 1px solid #acacac;
        border-radius: 5px;
        .mt-progress-content {
          .mt-progress-runway {
            background-color: #fff;
          }
          .mt-progress-progress {
            background-color: #d80c18;
            border-radius: 5px;
          }
        }
      }
    }
    /* .icon-style{
      flex:1;
      text-align:right;
      margin-right:20px;
      img{
        width:25px;
        height:25px;
      }
    } */
  }
  .nav {
    background: #fff;
    width: 100%;
    height: 65px;
    border-top: 1px solid #e4e4e4;
    // border-bottom: 5px solid #e4e4e4;
    display: flex;
    align-items: center;
    position: relative;
    .card-nav {
      position: absolute;
      width: 80%;
      background-color: #e8d3a2;
      top: -16px;
      left: 10%;
      height: 16px;
      border-radius: 6px 6px 0px 0px;
    }
    .nav-items {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // height:40px;
      width: 50%;
      font-size: 14px;
      span {
        color: #d80c18;
        margin-bottom: 5px;
        font-weight: bold;
        // font-size: 14px;
      }
    }
    .nav-items:first-child {
      border-right: 1px solid #e4e4e4;
    }
  }
  .advertise-img {
    // padding:15px 10px 0 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .menu-list {
    margin: 0 6px 6px 6px;
    padding: 24px 22px 24px;
    background-color: #fff;
    .line-items {
      display: flex;
      align-items: center;
      height: 84px;
      border-bottom: 1px solid #dcdddd;
      .content:nth-child(3n) {
        border-right: none;
      }
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        font-size: 14px;
        border-right: 1px solid #dcdddd;
        img {
          margin-bottom: 5px;
          width: 25px;
          height: 25px;
        }
      }
    }
    .line-items:last-child {
      border-bottom: 0;
    }
  }
  .foot {
    position: absolute;
    bottom: 5px;
    text-align: center;
  }
  #footer.indexFooter {
    text-align: center;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: none;
    img {
      width: 45%;
    }
  }
}

.bannerItem {
  width: 100%;
  position: relative;
  padding-bottom: 28.5%;
  height: 0;
}
.bannerItem:last-child {
  // margin-bottom: 40px;
}
.bannerItemTitle {
  padding: 10px 0;
  text-align: center;
}
.bannerItem > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100% !important;
}
.mint-swipe-item img {
  width: 100%;
  // height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/Member/Index.vue